<p-card>
  <div class="flex flex-col md:px-4 md:py-2">
    <h2 class="text-black font-app-bold text-lg mb-6">
      {{ "storedDocuments.fileEditionSubtitle" | translate }}
    </h2>
    <form
      *ngIf="formGroup"
      [formGroup]="formGroup"
      class="flex flex-col">
      <label
        for="editionFileName"
        class="font-app-regular"
        >{{ "storedDocuments.fileForm.nameInput" | translate }}
        <span class="text-red">{{ "storedDocuments.required" | translate }}</span></label
      >
      <input
        id="editionFileName"
        formControlName="name"
        type="text"
        pInputText
        maxlength="30"
        max="30"
        class="font-app-regular text-black border-2 border-light rounded-md px-4 py-2 mt-2" />
      <label
        for="editionCategory"
        class="font-app-regular mt-4"
        >{{ "storedDocuments.fileForm.categoryInput" | translate }}
        <span class="text-red">{{ "storedDocuments.required" | translate }}</span></label
      >
      <p-dropdown
        id="editionCategory"
        formControlName="categoryId"
        [options]="categories"
        optionValue="id"
        optionLabel="name"
        styleClass="w-full border-2 border-light rounded-md mt-2">
        <ng-template
          pTemplate="item"
          let-category>
          <div class="p-dropdown-item-container px-3 py-2 gap-2 rounded-md">
            <span class="flex-initial text-sm text-black">{{
              category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate)
            }}</span>
          </div>
        </ng-template>
        <ng-template
          pTemplate="selectedItem"
          let-category>
          <span class="p-0">{{
            category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate)
          }}</span>
        </ng-template></p-dropdown
      >
      <div class="flex flex-col md:flex-row-reverse gap-3 mt-6">
        <button
          pButton
          [label]="'storedDocuments.fileForm.validateButton' | translate"
          [disabled]="!formGroup.valid"
          (click)="validateEdition()"
          class="p-button bg-primary border-2 border-primary text-white font-bold w-full justify-center px-6 py-3"
          styleClass="focus:shadow-none rounded-none"></button>
        <button
          pButton
          [label]="'storedDocuments.fileForm.cancelButton' | translate"
          (click)="cancelEdition()"
          class="p-button bg-transparent border-2 border-primary text-primary font-bold w-full justify-center px-6 py-3"
          styleClass="focus:shadow-none rounded-none"></button>
      </div>
    </form>
  </div>
</p-card>

